<div *ngFor="let theme of themes" class="theme-item">
        <div class="image" [style.background-image]="'url('+theme.image+')'"></div>
        <div class="name w-30">{{theme.name}}</div>
        <div class="region w-30">{{theme.region}}</div>
        <div>
            <!--Deleting the theme trigger-->
            <i (click)="delete.emit(theme.id)" class="fas fa-trash" placement="top" ngbTooltip="Delete"></i>
            <!--Editing the theme trigger-->
            <i (click)="edit.emit(theme)" class="fas fa-edit" placement="top" ngbTooltip="Edit"></i>
        </div>
    </div>
